import MainPageFrame from '../../_common/elements/MainPageFrame';

function Customer() {
    const data = {
        title: 'Overview',
        address: '/customer',
    };
    return <MainPageFrame data={data} />;
}

export default Customer;
